export default __webpack_public_path__ + "static/media/acms-wiki.b6645aae.svg";